import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export interface IFeedback {
    lan_id: string
    feedback_ease_of_use: number
    feedback_meets_needs: number
    feedback_location: string
    feedback_comments: string
}

export const createFeedback = fetchGeneralData<IFeedback, IFeedback>(
    `${ApiSubUrls[Apis.FEEDBACK]}`,
)
